module.exports = __webpack_public_path__ + "img/03.6a302c2d.jpg";